/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMeResponseDto } from '../../models/backend-me-response-dto';

export interface MeAuthMeGet$Params {}

export function meAuthMeGet(
  http: HttpClient,
  rootUrl: string,
  params?: MeAuthMeGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMeResponseDto>> {
  const rb = new RequestBuilder(rootUrl, meAuthMeGet.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMeResponseDto>;
    }),
  );
}

meAuthMeGet.PATH = '/auth/me';
